import { render, staticRenderFns } from "./MTerminalForm.vue?vue&type=template&id=08cc6e8a"
import script from "./MTerminalForm.vue?vue&type=script&lang=js"
export * from "./MTerminalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports